import {useEffect, useState} from 'react';
import {StatesButtonStates} from '@wix/wix-ui-tpa/cssVars';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {useMemberDetailsData} from '../../../MemberDetails/WithMemberDetailsData';
import {ADD_NEW_ADDRESS_ID} from '../../../constants';
import {StepId} from '../../../../../types/checkoutApp.types';
import {useBillingData} from './WithBillingData';
import {shouldHideBillingDetailsSection} from '../../../../../domain/utils/billingDetails.utils';
import {usePaymentsApi} from '../../../../../common/components/WithPaymentsApi/WithPaymentsApi';
import {useExperiments} from '@wix/yoshi-flow-editor';

export function UsePlaceOrderButtonState() {
  const {
    checkoutStore: {isPlaceOrderButtonDisabled, modalError, isFastFlow, cart, cartSummary},
    formsStore: {areFormsLoaded},
    stepsManagerStore: {activeStep},
    memberStore: {isMember},
  } = useControllerProps();
  const {activePaymentId} = usePaymentsApi();
  const {experiments} = useExperiments();

  const {editMode, selectedAddressesServiceId, areMemberDetailsValid} = useMemberDetailsData();
  const {isShippingValidForBilling, billingSameAsShipping} = useBillingData();

  const [placeOrderButtonState, setPlaceOrderButtonState] = useState(StatesButtonStates.IDLE);

  const shouldRequirePayment = cartSummary?.paymentSummary.requiresPaymentAfterGiftCard;

  const [shouldPlaceOrderButtonBeDisabled, setShouldPlaceOrderButtonBeDisabled] = useState(
    (!isFastFlow && activeStep.stepId === StepId.paymentAndPlaceOrder && shouldRequirePayment && !areFormsLoaded) ||
      isPlaceOrderButtonDisabled
  );

  // eslint-disable-next-line sonarjs/cognitive-complexity
  useEffect(() => {
    if (modalError) {
      setPlaceOrderButtonState(StatesButtonStates.IDLE);
      setShouldPlaceOrderButtonBeDisabled(isPlaceOrderButtonDisabled);
    }

    if (isFastFlow && placeOrderButtonState !== StatesButtonStates.IN_PROGRESS) {
      setShouldPlaceOrderButtonBeDisabled(isPlaceOrderButtonDisabled);
    } else if (activeStep.stepId === StepId.paymentAndPlaceOrder && shouldRequirePayment && isMember) {
      const disableButtonByBillingSection = !shouldHideBillingDetailsSection(cart, activePaymentId);

      const disablePlaceOrderButton =
        !areFormsLoaded ||
        (!areMemberDetailsValid && !editMode && selectedAddressesServiceId !== ADD_NEW_ADDRESS_ID) ||
        editMode ||
        (selectedAddressesServiceId === ADD_NEW_ADDRESS_ID && disableButtonByBillingSection);

      const checkIfPlaceOrderButtonShouldBeDisabledInCaseOfAddressDeleted =
        isShippingValidForBilling && billingSameAsShipping ? false : disablePlaceOrderButton;

      if (placeOrderButtonState !== StatesButtonStates.IN_PROGRESS) {
        setShouldPlaceOrderButtonBeDisabled(
          checkIfPlaceOrderButtonShouldBeDisabledInCaseOfAddressDeleted || isPlaceOrderButtonDisabled
        );
      }
    } else if (placeOrderButtonState !== StatesButtonStates.IN_PROGRESS) {
      setPlaceOrderButtonState(StatesButtonStates.IDLE);
      setShouldPlaceOrderButtonBeDisabled(!areFormsLoaded || isPlaceOrderButtonDisabled);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    areFormsLoaded,
    areMemberDetailsValid,
    editMode,
    selectedAddressesServiceId,
    activeStep,
    isFastFlow,
    isPlaceOrderButtonDisabled,
    shouldRequirePayment,
    placeOrderButtonState,
    isMember,
    isShippingValidForBilling,
    billingSameAsShipping,
    experiments,
    activePaymentId,
    modalError,
  ]);

  return {
    placeOrderButtonState,
    shouldPlaceOrderButtonBeDisabled,
    setPlaceOrderButtonState,
    setShouldPlaceOrderButtonBeDisabled,
  };
}
